import { forceExcelTextCsvCell } from '../domain/excelCsvNumeric';

export function escapeCsvCell(value: string): string {
  const safe = forceExcelTextCsvCell(value ?? '');
  if (/[",;\n\r\t]/.test(safe) || safe !== (value ?? '')) {
    return `"${safe.replace(/"/g, '""')}"`;
  }
  return safe;
}

export function buildCsvFromRows(
  headers: string[],
  rows: string[][],
  delimiter = ','
): string {
  const headerLine = headers.map(escapeCsvCell).join(delimiter);
  const dataLines = rows.map((row) =>
    row.map((cell) => escapeCsvCell(String(cell ?? ''))).join(delimiter)
  );
  return [headerLine, ...dataLines].join('\n');
}
